import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { Modal, CppEstimator } from 'components';
import { Planning } from 'actions';

class CppModal extends Component {
  state = {
    tableOpen: false,
  };

  setTableOpen = (tableOpen) => this.setState({ tableOpen });

  updateInfo = (
    yearsWorked,
    caregiver,
    yearsCare,
    exceedIncome,
    exceedIncomeBy
  ) => {
    const { dispatch } = this.props;
    dispatch(
      Planning.drawdownUpdateInput({
        inputs: {
          years_contrib: yearsWorked,
          primary_caregiver: caregiver,
          years_primary_caregiver: yearsCare,
          is_earning_over_average: exceedIncome,
          perc_under_average: exceedIncomeBy,
        },
      })
    );
  };

  render() {
    const { isOpen, toggle, updateCppInfo, cppDataset, drawdown } = this.props;
    const { tableOpen } = this.state;
    const { inputs } = drawdown || {};

    return (
      <Modal open={isOpen} dimmerClick={() => !tableOpen && toggle(false)}>
        <Modal.Content style={{ position: 'relative', padding: '2rem' }}>
          <CloseIcon onClick={() => toggle(false)}>+</CloseIcon>

          <CppEstimator
            toggle={toggle}
            updateCppInfo={updateCppInfo}
            cppDataset={cppDataset}
            setTableOpen={this.setTableOpen}
            clientAge={inputs.age}
            clientProvince={inputs.prov}
            personalDetails={inputs}
            updateInfo={this.updateInfo}
            closeModal={() => toggle(false)}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

CppModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  updateCppInfo: PropTypes.func.isRequired,
  cppDataset: PropTypes.array,
  drawdown: PropTypes.object,
  dispatch: PropTypes.func,
};

CppModal.defaultProps = {
  cppDataset: [],
  drawdown: {},
  dispatch: () => false,
};

const mapStateToProps = (state) => ({
  // isOpen: state.Planning.isCppModalOpen, // Assuming isCppModalOpen is stored in the Planning reducer
  drawdown: state.Planning.drawdown,
});

export default connect(mapStateToProps)(CppModal);

const CloseIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
  text-align: center;
  font-size: 1.7rem;
  border-radius: 50%;
  line-height: 19px;
  transform: rotate(45deg);
  transition: all 0.1s ease;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    color: #fff6f6;
  }
`;
